'use strict';

var index = require('../numbers/index.cjs');
var units = require('../numbers/units.cjs');

const transformValueTypes = {
    rotate: units.degrees,
    rotateX: units.degrees,
    rotateY: units.degrees,
    rotateZ: units.degrees,
    scale: index.scale,
    scaleX: index.scale,
    scaleY: index.scale,
    scaleZ: index.scale,
    skew: units.degrees,
    skewX: units.degrees,
    skewY: units.degrees,
    distance: units.px,
    translateX: units.px,
    translateY: units.px,
    translateZ: units.px,
    x: units.px,
    y: units.px,
    z: units.px,
    perspective: units.px,
    transformPerspective: units.px,
    opacity: index.alpha,
    originX: units.progressPercentage,
    originY: units.progressPercentage,
    originZ: units.px,
};

exports.transformValueTypes = transformValueTypes;
//# sourceMappingURL=transform.cjs.map
